import { render, staticRenderFns } from "./index.vue?vue&type=template&id=82c2b3ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c2b3ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82c2b3ba')) {
      api.createRecord('82c2b3ba', component.options)
    } else {
      api.reload('82c2b3ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=82c2b3ba&scoped=true", function () {
      api.rerender('82c2b3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-business/com-detail/index.vue"
export default component.exports